import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppointmentStore } from "src/features/appointment/services/useAppointmentStore";
import { ClientMode } from "../../../../core/backend/clients/backendClient";
import { logService } from "../../../../core/services/logService";
import { useAuthStore } from "../../../auth/services/useAuthStore";
import { useSettingsStore } from "../../../settings/services/useSettingsStore";
import LandingBottom from "./components/LandingBottom/LandingBottom";
import LandingTop from "./components/LandingTop/LandingTop";
import "./LandingPage.css";

function LandingPage() {
  const navigate = useNavigate();

  const authStore = useAuthStore();
  const appointmentStore = useAppointmentStore();
  const settingsStore = useSettingsStore();

  useEffect(() => {
    logService.log("LandingPage component mounted");

    if (authStore.user.isLoggedIn) navigate("/home");

    appointmentStore.clear();
  }, []);

  return (
    <div className="landingPage">
      <LandingTop />
      {settingsStore.clientConfiguration.mode !== ClientMode.Magan && (
        <LandingBottom />
      )}
    </div>
  );
}

export default LandingPage;
